import axios from 'axios'
import { CustomException } from '../utils/exceptions'

export const getFichiersImportation = async () => {
  const response = await axios.get('/admin/fichierimportation/fetch')
    .catch((e) => {
    throw new CustomException(e, 'Error fetching fichiers importation')
  })
  return response.data
}

export const renommerFichierImportation = async nom => {
  const response = await axios.get('/admin/fichierimportation/rename/' + nom)
    .catch((e) => {
      throw new CustomException(e, 'Error renaming fichier importation')
    })
  return response.data
}

export const supprimerFichierImportation = async nom => {
  const response = await axios.get('/admin/fichierimportation/delete/' + nom)
    .catch((e) => {
      throw new CustomException(e, 'Error deleting fichier importation')
    })
  return response.data
}
